/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import CloseOutlined from '@mui/icons-material/CloseOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import {
  Container,
  Box,
  Typography,
  Grid,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  TextField,
  Divider,
  Stack,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Chip,
  ListItem,
  ListItemText,
  FormHelperText,
  DialogContentText,
  List,
  Skeleton,
} from '@mui/material';
import _ from 'lodash';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Table } from 'wae_rwlb_reactlibrary';

import {
  getCustomerTableData,
  getCustomerTableDataByFilter,
  getEquipmentList,
  submitComplaint,
  resetEquipmentData,
} from '../../actions';
import { Wizard, TextBox } from '../../components/index';
import { COLOR } from '../../helpers/colors';
import { textBoxStyle } from './styles';
import TablePlaceholder from './TablePlaceholder';

const columnsConfig = t => [
  {
    field: 'col1',
    headerName: t('complaintScreenTranslations:CUSTOMER'),
    key: 'BusinessPartner',
    width: 150,
  },
  {
    field: 'col4',
    headerName: t('complaintScreenTranslations:NAME'),
    key: 'BusinessPartnerName',
    width: 150,
    flex: 1,
  },
];
const columnsConfigEquipment = t => [
  {
    field: 'col1',
    headerName: t('complaintScreenTranslations:EQUIPMENT'),
    key: 'Equipment',
    width: 150,
    flex: 1,
  },
  {
    field: 'col2',
    headerName: t('complaintScreenTranslations:MODEL_TEXT'),
    key: 'ModelText',
    width: 150,
    flex: 1,
  },
  {
    field: 'col3',
    headerName: t('complaintScreenTranslations:LICENSE_NUMBER'),
    key: 'LicenseNumber',
    width: 150,
    flex: 1,
  },
];

class Complaint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selectedRows: [],
      page: 0,
      rowsPerPage: 20,
      name: '',
      equipmentList: [],
      equipment: '',
      complaintSubject: '',
      complaintDetails: '',
      setContactOpen: false,
      searchTerm: '',
      customerSearchTerm: '',
      nameSearchTerm: '',
      toggleInput: false,
      toggleEquipmentInput: false,
      customerList: [],
      nameSearchTermList: [],
      open: false,
      selectedField: 'customerList',
      BusinessPartner: '',
      isDialogMainOpen: false,
      dialogMainContent: '',
      dialogMainTitle: '',
      setEquipmentOpen: false,
      equipmentText: '',
      showEquipmentPopUp: false,
      modelTextTerm: '',
      modelTextTermList: [],
      licenceNumberTerm: '',
      licenceNumberTermList: [],
    };
  }

  async componentDidMount() {
    try {
      const { page, rowsPerPage } = this.state;
      const skip = page;
      const top = rowsPerPage;
      await this.props.getCustomerTableData(skip, top);
      this.loadData();
    } catch (err) {
      console.log(err);
    }
  }

  loadData = () => {
    try {
      const { customerDataArr, equipmentData } = this.props.sales;
      this.setState({
        data: customerDataArr,
        equipmentList: equipmentData,
        selectedRows: [],
        customerSearchTerm: '',
        nameSearchTerm: '',
      });
    } catch (err) {
      console.log(err);
    }
  };

  resetData = () => {
    this.setState({
      complaintDetails: '',
      complaintSubject: '',
      name: '',
      equipment: '',
      equipmentText: '',
      showEquipmentPopUp: false,
    });
    this.props.resetEquipmentData();
  };

  returnFilterStr = (condition1, condition2) => {
    try {
      let filterStr = '';
      const list1 = condition1.value;
      const field1 = condition1.field;
      const list2 = condition2.value;
      const field2 = condition2.field;
      if (!_.isEmpty(list1)) {
        const d = [];
        list1.forEach(c => {
          return d.push(`${field1} eq '${c.title}'`);
        });
        filterStr = d.join(' or ');
      }
      if (!_.isEmpty(list2)) {
        const d = [];
        if (filterStr === '') {
          list2.forEach(n => {
            return d.push(`${field2} eq '${n.title}'`);
          });
        } else {
          list2.forEach(n => {
            return d.push(`(${filterStr}) and ${field2} eq '${n.title}'`);
          });
        }
        filterStr = d.join(' or ');
      }
      return filterStr;
    } catch (err) {
      console.log(err);
      return '';
    }
  };

  resetSearchFilter = () => {
    this.setState({
      searchTerm: '',
    });
  };

  showEquipmentPopUp = () => {
    const { equipmentData } = this.props.sales;
    this.setState({ showEquipmentPopUp: equipmentData.length > 5 });
  };

  loadEquipmentData = () => {
    try {
      const { equipmentData } = this.props.sales;
      this.setState({
        equipmentList: equipmentData,
        selectedRows: [],
        modelTextTerm: '',
        licenceNumberTerm: '',
      });
    } catch (err) {
      console.log(err);
    }
  };

  saveChipsAndReturnFilterStr = () => {
    try {
      const { customerList, nameSearchTermList, customerSearchTerm, nameSearchTerm } = this.state;
      const customerListNew = customerList;
      const nameSearchTermListNew = nameSearchTermList;
      if (customerSearchTerm !== '') {
        customerListNew.push({ title: customerSearchTerm });
        this.setState({
          customerList: customerListNew,
          customerSearchTerm: '',
        });
      }
      if (nameSearchTerm !== '') {
        nameSearchTermListNew.push({ title: nameSearchTerm });
        this.setState({
          nameSearchTermList: nameSearchTermListNew,
          nameSearchTerm: '',
        });
      }
      return this.returnFilterStr(
        { field: 'BusinessPartner', value: customerListNew },
        { field: 'BusinessPartnerName', value: nameSearchTermListNew }
      );
    } catch (err) {
      console.log(err);
      return '';
    }
  };

  saveChipsReturnFilterStrEquipment = () => {
    try {
      const {
        modelTextTermList,
        licenceNumberTermList,
        modelTextTerm,
        licenceNumberTerm,
      } = this.state;
      const list1 = modelTextTermList;
      const list2 = licenceNumberTermList;
      if (modelTextTerm !== '') {
        list1.push({ title: modelTextTerm });
        this.setState({
          modelTextTermList: list1,
          modelTextTerm: '',
        });
      }
      if (licenceNumberTerm !== '') {
        list2.push({ title: licenceNumberTerm });
        this.setState({
          licenceNumberTermList: list2,
          licenceNumberTerm: '',
        });
      }
      return this.returnFilterStr(
        { field: 'ModelText', value: list1 },
        { field: 'LicenseNumber', value: list2 }
      );
    } catch (err) {
      console.log(err);
      return '';
    }
  };

  isSearchTermEquipment = () => {
    const {
      searchTerm,
      modelTextTerm,
      licenceNumberTerm,
      modelTextTermList,
      licenceNumberTermList,
    } = this.state;
    return (
      searchTerm !== '' &&
      modelTextTerm === '' &&
      licenceNumberTerm === '' &&
      _.isEmpty(modelTextTermList) &&
      _.isEmpty(licenceNumberTermList)
    );
  };

  handleGoSearchSubmitEquipment = async () => {
    try {
      const { searchTerm, BusinessPartner, rowsPerPage, page } = this.state;
      const top = rowsPerPage;
      const skip = page * rowsPerPage;
      let filterStr = `Partner eq '${BusinessPartner}' and ModelText ne ' ' and LicenseNumber ne ' '`;
      if (this.isSearchTermEquipment()) {
        const subCondition1 = `substringof('${searchTerm}', Equipment) eq true`;
        const subCondition2 = `substringof('${searchTerm}', ModelText) eq true`;
        const subCondition3 = `substringof('${searchTerm}', LicenseNumber) eq true`;
        filterStr = `${filterStr} and (${subCondition1} or ${subCondition2} or ${subCondition3})`;
      } else {
        const filterStrNew = this.saveChipsReturnFilterStrEquipment();
        filterStr = filterStrNew !== '' ? `${filterStr} and ${filterStrNew}` : filterStr;
      }
      await this.props.getEquipmentList(filterStr, skip, top);
      this.loadEquipmentData();
    } catch (err) {
      console.log(err);
    }
  };

  handlePageChangeEquipment = async (e, value) => {
    this.setState({ page: value }, () => this.handleGoSearchSubmitEquipment());
    window.scrollTo(0, 0);
  };

  isSearchTermContact = () => {
    const {
      searchTerm,
      customerSearchTerm,
      nameSearchTerm,
      customerList,
      nameSearchTermList,
    } = this.state;

    return (
      searchTerm !== '' &&
      customerSearchTerm === '' &&
      nameSearchTerm === '' &&
      _.isEmpty(customerList) &&
      _.isEmpty(nameSearchTermList)
    );
  };

  handleGoSearchSubmit = async () => {
    try {
      const { rowsPerPage, page, searchTerm } = this.state;
      const top = rowsPerPage;
      const skip = page * rowsPerPage;
      let filterStr = '';
      if (this.isSearchTermContact()) {
        const subCondition1 = `substringof('${searchTerm}', BusinessPartner) eq true`;
        const subCondition2 = `substringof('${searchTerm}', BusinessPartnerName) eq true`;
        filterStr = `${subCondition1} or ${subCondition2}`;
      } else {
        filterStr = this.saveChipsAndReturnFilterStr();
      }
      await this.props.getCustomerTableDataByFilter(skip, top, filterStr);
      this.loadData();
    } catch (err) {
      console.log(err);
    }
  };

  handlePageChange = async (e, value) => {
    this.setState({ page: value }, () => this.handleGoSearchSubmit());
    window.scrollTo(0, 0);
  };

  handleSuccess = (resetWizard, t) => {
    this.setState({
      isDialogMainOpen: true,
      dialogMainContent: t('complaintScreenTranslations:CUSTOMER_COMPLAINT_CREATION_SUCCESSFUL'),
      dialogMainTitle: t('complaintScreenTranslations:SUCCESS'),
    });
    resetWizard();
    this.resetData();
  };

  handleFail = (resetWizard, t) => {
    this.setState({
      isDialogMainOpen: true,
      dialogMainContent: t('complaintScreenTranslations:CUSTOMER_COMPLAINT_CREATION_FAILED'),
      dialogMainTitle: t('complaintScreenTranslations:FAILED'),
    });
    resetWizard();
    this.resetData();
  };

  handleSubmit = resetWizard => {
    try {
      const { equipment, complaintSubject, complaintDetails, BusinessPartner } = this.state;
      const { selectedSalesOrgData } = this.props.auth;
      const { SalesOff } = selectedSalesOrgData;

      const data = {
        ActivityPartner: BusinessPartner,
        ContactPerson: BusinessPartner,
        ComplaintText: complaintSubject,
        Description: complaintDetails,
        Equipment: equipment,
        Vkbur: SalesOff,
      };
      this.props.submitComplaint(
        data,
        () => this.handleSuccess(resetWizard),
        () => this.handleFail(resetWizard),
        this.props.enqueueSnackbar
      );
    } catch (error) {
      console.log('error at submit', error);
    }
  };

  handleMainDialogClose = () => {
    this.setState({ isDialogMainOpen: false, dialogMainContent: '', dialogMainTitle: '' });
    this.resetData();
  };

  handleChangeComplaintDetails = e => {
    this.setState({
      complaintDetails: e.target.value,
    });
  };

  handleChangeComplaintSubject = e => {
    this.setState({
      complaintSubject: e.target.value,
    });
  };

  clearContactPerson = () => {
    this.setState(
      {
        name: '',
        equipmentList: [],
        equipmentText: '',
        showEquipmentPopUp: false,
        equipment: '',
        customerSearchTerm: '',
        customerList: [],
        nameSearchTerm: '',
        nameSearchTermList: [],
        page: 0,
      },
      () => this.handleGoSearchSubmit()
    );
    this.props.resetEquipmentData();
  };

  handleContactDialogOpen = () => {
    this.setState({
      setContactOpen: true,
    });
  };

  handleContactDialogClose = () => {
    this.setState({
      setContactOpen: false,
    });
  };

  handleEquipmentDialogOpen = () => {
    this.setState({
      setEquipmentOpen: true,
    });
  };

  handleEquipmentDialogClose = () => {
    this.setState({
      setEquipmentOpen: false,
    });
  };

  clearEquipmentText = () => {
    this.setState(
      {
        equipmentText: '',
      },
      () => this.handleGoSearchSubmitEquipment()
    );
  };

  handleSearchContact = () => {
    this.setState({ page: 0 }, () => this.handleGoSearchSubmit());
  };

  handleSearchEquipment = () => {
    this.setState({ page: 0 }, () => this.handleGoSearchSubmitEquipment());
  };

  handleSaveContact = () => {
    try {
      const { data, selectedRows } = this.state;
      const { BusinessPartnerName, BusinessPartner } = data[selectedRows[0]];

      this.setState(
        {
          setContactOpen: false,
          name: BusinessPartnerName,
          BusinessPartner,
          searchTerm: '',
          selectedRows: [],
        },
        async () => {
          const filterStr = `Partner eq '${BusinessPartner}' and ModelText ne ' ' and LicenseNumber ne ' '`;
          await this.props.getEquipmentList(filterStr, 0, 20);
          this.showEquipmentPopUp();
          this.loadEquipmentData();
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  handleSaveEquipment = () => {
    try {
      const { selectedRows } = this.state;
      const { equipmentData } = this.props.sales;
      const { Equipment, ModelText, LicenseNumber } = equipmentData[selectedRows[0]];

      this.setState({
        setEquipmentOpen: false,
        equipmentText: `${ModelText} (${LicenseNumber})`,
        equipment: Equipment,
        searchTerm: '',
        selectedRows: [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  toggleAdvanceSearch = () => {
    const { toggleInput } = this.state;
    this.setState({
      toggleInput: !toggleInput,
    });
  };

  toggleAdvanceSearchEquipment = () => {
    const { toggleEquipmentInput } = this.state;
    this.setState({
      toggleEquipmentInput: !toggleEquipmentInput,
    });
  };

  handleListDialogClose = () => {
    this.setState({ open: false });
  };

  removeItems = c => {
    try {
      const { selectedField } = this.state;
      const isOpen = this.state[selectedField].length > 1;
      this.setState(prevState => ({
        [selectedField]: prevState[selectedField].filter(d => d.title !== c.title),
        open: isOpen,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  handleSearchChange = e => {
    this.setState({ searchTerm: e.target.value });
  };

  handleKeyPress = ev => {
    try {
      if (ev.key === 'Enter') {
        this.handleSearchContact();
        ev.preventDefault();
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleKeyPressEquipment = ev => {
    try {
      if (ev.key === 'Enter') {
        this.handleSearchEquipment();
        ev.preventDefault();
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleModelChange = s => {
    try {
      this.setState({ selectedRows: s.slice(s.length - 1) });
    } catch (err) {
      console.log(err);
    }
  };

  renderModelTags = (tagValue, getTagProps) => {
    return this.returnChips(tagValue, getTagProps, 'modelTextTermList');
  };

  renderLicenseTags = (tagValue, getTagProps) => {
    return this.returnChips(tagValue, getTagProps, 'licenceNumberTermList');
  };

  renderCustomerTags = (tagValue, getTagProps) => {
    return this.returnChips(tagValue, getTagProps, 'customerList');
  };

  renderNameTags = (tagValue, getTagProps) => {
    return this.returnChips(tagValue, getTagProps, 'nameSearchTermList');
  };

  handleCustomerListChange = (event, newValue) => {
    try {
      if (event.key !== 'Enter') {
        this.setState({ customerList: newValue });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleCustomerTextChange = (event, newInputValue) => {
    try {
      const { customerList, customerSearchTerm } = this.state;
      if (event !== null && event.key !== 'Enter') {
        this.setState({
          customerSearchTerm: newInputValue,
        });
      } else {
        const a = customerList;
        a.push({ title: customerSearchTerm });
        this.setState({
          customerList: a,
          customerSearchTerm: '',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleNameListChange = (event, newValue) => {
    try {
      if (event.key !== 'Enter') {
        this.setState({ nameSearchTermList: newValue });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleNameTextChange = (event, newInputValue) => {
    try {
      const { nameSearchTerm, nameSearchTermList } = this.state;
      if (event.key !== 'Enter') {
        this.setState({
          nameSearchTerm: newInputValue,
        });
      } else {
        const a = nameSearchTermList;
        a.push({ title: nameSearchTerm });
        this.setState({
          nameSearchTermList: a,
          nameSearchTerm: '',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleModelTextListChange = (event, newValue) => {
    try {
      if (event.key !== 'Enter') {
        this.setState({ modelTextTermList: newValue });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleModelTextChange = (event, newInputValue) => {
    try {
      const { modelTextTermList, modelTextTerm } = this.state;
      if (event.key !== 'Enter') {
        this.setState({
          modelTextTerm: newInputValue,
        });
      } else {
        const a = modelTextTermList;
        a.push({ title: modelTextTerm });
        this.setState({
          modelTextTermList: a,
          modelTextTerm: '',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleLicenseListChange = (event, newValue) => {
    try {
      if (event.key !== 'Enter') {
        this.setState({
          licenceNumberTermList: newValue,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleLicenseTextChange = (event, newInputValue) => {
    try {
      const { licenceNumberTerm, licenceNumberTermList } = this.state;
      if (event.key !== 'Enter') {
        this.setState({
          licenceNumberTerm: newInputValue,
        });
      } else {
        const a = licenceNumberTermList;
        a.push({ title: licenceNumberTerm });
        this.setState({
          licenceNumberTermList: a,
          licenceNumberTerm: '',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleChangeEquipment = e => {
    this.setState({ equipment: e.target.value });
  };

  handleLargeTags = () => {
    this.setState({
      open: true,
    });
  };

  renderTextField = params => (
    <TextField
      {...params}
      InputProps={{
        ...params.InputProps,
        type: 'search',
      }}
    />
  );

  renderEquipmentText = () => {
    const { t } = this.props;
    const { equipmentText } = this.state;

    return equipmentText !== '' ? (
      <Chip label={equipmentText} onDelete={this.clearEquipmentText} />
    ) : (
      <Typography variant="subtitle1" color={COLOR.lightTextColor}>
        {t('complaintScreenTranslations:CONTACT_PERSON_AND_EQUIPMENT_DETAILS')}
      </Typography>
    );
  };

  returnChips = (tagValue, getTagProps) => {
    const { t } = this.props;
    const isLargeText = tagValue.length > 2;

    return (
      <Stack direction="row" justifyContent="space-between">
        {tagValue.map((option, index) => {
          const label =
            option.title.length <= 15 ? option.title : `${option.title.slice(0, 15)}...`;
          return index < 2 ? (
            <Chip key={index.toString()} label={`=${label}`} {...getTagProps({ index })} />
          ) : null;
        })}

        {isLargeText ? (
          <Button onClick={this.handleLargeTags}>
            {`${tagValue.slice(2).length} ${t('complaintScreenTranslations:MORE')}`}{' '}
          </Button>
        ) : null}
      </Stack>
    );
  };

  renderSelectEquipmentChild = () => {
    const { name, equipment, showEquipmentPopUp } = this.state;
    const { sales, t } = this.props;
    const { equipmentData } = sales;
    return !showEquipmentPopUp ? (
      <FormControl fullWidth>
        <InputLabel> {t('complaintScreenTranslations:SELECT_EQUIPMENT')}</InputLabel>
        <Select
          id="outlined-basic"
          label={t('complaintScreenTranslations:SELECT_EQUIPMENT')}
          value={equipment}
          onChange={this.handleChangeEquipment}
          variant="outlined"
          disabled={name === '' || _.isEmpty(equipmentData)}
        >
          {equipmentData.map((item, index) => (
            <MenuItem key={index.toString()} value={item.Equipment}>
              {item.ModelText} ({item.LicenseNumber})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : (
      <Box sx={textBoxStyle}>
        {this.renderEquipmentText()}

        <IconButton
          aria-label="toggle password visibility"
          onClick={this.handleEquipmentDialogOpen}
          edge="end"
        >
          <OpenInNewIcon />
        </IconButton>
      </Box>
    );
  };

  renderContactSection = () => {
    const { name } = this.state;
    const { sales, t } = this.props;
    const { failText, isEquipmentLoading, failTextEquipment } = sales;
    return (
      <Grid item xs={12} sx={{ mt: 2 }} nextValidation={name !== ''}>
        <Typography sx={{ fontSize: { xs: 14, sm: 16, md: 24 } }}>
          {t('complaintScreenTranslations:CONTACT_PERSON_AND_EQUIPMENT_DETAILS')}
        </Typography>

        <Divider sx={{ marginY: 2 }} />

        <Grid item container xs={12} direction="row" justifyContent="center">
          <Grid item xs={12} sm={12} md={5}>
            <Grid item container sx={{ mt: 2 }}>
              <Box sx={textBoxStyle}>
                {name !== '' ? (
                  <Chip label={name} onDelete={this.clearContactPerson} />
                ) : (
                  <Typography variant="subtitle1" color={COLOR.lightTextColor}>
                    {t('complaintScreenTranslations:SELECT_CONTACT_PERSON')}
                  </Typography>
                )}

                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleContactDialogOpen}
                  edge="end"
                >
                  <OpenInNewIcon />
                </IconButton>
              </Box>
              <FormHelperText sx={{ color: COLOR.errorTextColor }}>{failText}</FormHelperText>
            </Grid>

            <Grid item container sx={{ mt: 2 }}>
              {isEquipmentLoading ? (
                <Skeleton
                  animation="wave"
                  variant="text"
                  color={COLOR.PH}
                  sx={{
                    width: '100%',
                    height: 90,
                    mt: -2,
                  }}
                />
              ) : (
                this.renderSelectEquipmentChild()
              )}
              <FormHelperText sx={{ color: COLOR.errorTextColor }}>
                {failTextEquipment}
              </FormHelperText>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderComplaintSection = () => {
    const { complaintSubject, complaintDetails } = this.state;
    const { t } = this.props;

    return (
      <Grid
        item
        xs={12}
        sx={{ mt: 2 }}
        nextValidation={complaintSubject !== '' && complaintDetails !== ''}
      >
        <Grid item xs={12}>
          <Typography sx={{ fontSize: { xs: 14, sm: 16, md: 24 } }}>
            {t('complaintScreenTranslations:COMPLAINT_DETAILS')}
          </Typography>

          <Divider sx={{ marginY: 2 }} />
          <Grid item container xs={12} direction="row" justifyContent="center">
            <Grid item xs={12} sm={12} md={5}>
              <Grid item sx={{ mt: 2 }}>
                <FormControl fullWidth>
                  <TextField
                    id="outlined-basic"
                    value={complaintSubject}
                    label={t('complaintScreenTranslations:COMPLAINT_SUBJECT')}
                    variant="outlined"
                    onChange={this.handleChangeComplaintSubject}
                    // disabled
                  />
                </FormControl>
              </Grid>
              <Grid item sx={{ mt: 2 }}>
                <FormControl fullWidth>
                  <TextField
                    id="outlined-basic"
                    value={complaintDetails}
                    label={t('complaintScreenTranslations:COMPLAINT_DETAILS')}
                    variant="outlined"
                    onChange={this.handleChangeComplaintDetails}
                    // disabled
                    multiline
                    rows={4}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderReviewSection = () => {
    const { t } = this.props;
    const { complaintSubject, complaintDetails, equipmentText, name } = this.state;
    const { auth } = this.props;
    const { selectedSalesOrgData } = auth;
    const { SalesOfficeName } = selectedSalesOrgData;

    return (
      <Grid item xs={12} sx={{ mt: 2 }}>
        <Typography sx={{ fontSize: { xs: 14, sm: 16, md: 24 } }}>
          {t('complaintScreenTranslations:REVIEW')}
        </Typography>
        <Divider sx={{ marginY: 2 }} />
        <Grid item xs={12}>
          <Stack direction="row" sx={{ mt: 2, alignItems: 'baseline' }}>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
              }}
              color={COLOR.helperTextColor}
            >
              {t('complaintScreenTranslations:SALES_ORGANIZATION')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
              }}
            >
              &nbsp;
              {SalesOfficeName}
            </Typography>
          </Stack>
          <Stack direction="row" sx={{ mt: 2, alignItems: 'baseline' }}>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
              }}
              color={COLOR.helperTextColor}
            >
              {t('complaintScreenTranslations:CONTACT_PERSON')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
              }}
            >
              &nbsp;{name}
            </Typography>
          </Stack>
          <Stack direction="row" sx={{ mt: 2, alignItems: 'baseline' }}>
            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
              }}
              color={COLOR.helperTextColor}
            >
              {t('complaintScreenTranslations:EQUIPMENT')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
              }}
            >
              &nbsp;
              {equipmentText !== '' ? equipmentText : '-'}
            </Typography>
          </Stack>
          <Stack direction="row" sx={{ mt: 2, alignItems: 'baseline' }}>
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
              }}
              color={COLOR.helperTextColor}
            >
              {t('complaintScreenTranslations:COMPLAINT_SUBJECT')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
              }}
            >
              &nbsp;{complaintSubject}
            </Typography>
          </Stack>
          <Stack direction="row" sx={{ mt: 2, alignItems: 'baseline' }} flexWrap="wrap">
            <Typography
              sx={{
                fontSize: { xs: 12, md: 14 },
                width: { xs: '100%', md: '100%', lg: '11%' },
              }}
              color={COLOR.helperTextColor}
            >
              {t('complaintScreenTranslations:COMPLAINT_DETAILS')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
                width: { xs: '100%', md: '100%', lg: '88%' },
              }}
            >
              &nbsp;{complaintDetails}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    );
  };

  render() {
    const {
      setContactOpen,
      data,
      selectedRows,
      searchTerm,
      customerSearchTerm,
      nameSearchTerm,
      toggleInput,
      toggleEquipmentInput,
      customerList,
      nameSearchTermList,
      page,
      rowsPerPage,
      open,
      selectedField,
      isDialogMainOpen,
      dialogMainContent,
      dialogMainTitle,
      setEquipmentOpen,
      equipmentList,
      modelTextTerm,
      modelTextTermList,
      licenceNumberTerm,
      licenceNumberTermList,
    } = this.state;
    const { sales } = this.props;
    const {
      listCount,
      isLoading,
      isEquipmentLoading,
      listCountEquipment,
      requestSubmitted,
    } = sales;
    const tableData = _.isEmpty(data) ? [] : data;
    const tableDataEquipment = _.isEmpty(equipmentList) ? [] : equipmentList;
    const { t } = this.props;
    return (
      <>
        <Container sx={{ mt: 2 }}>
          <Box>
            <Wizard
              ref={ref => {
                this.wizard = ref;
              }}
              steps={[
                t('complaintScreenTranslations:CONTACT_PERSON_&_EQUIPMENT'),
                t('complaintScreenTranslations:COMPLAINT_DETAILS'),
                t('complaintScreenTranslations:REVIEW'),
              ]}
              optional={[false, false, false]}
              onSubmit={resetWizard => {
                this.handleSubmit(resetWizard);
              }}
              onReset={this.resetData}
              requestSubmitted={requestSubmitted}
            >
              {this.renderContactSection()}
              {this.renderComplaintSection()}
              {this.renderReviewSection()}
            </Wizard>

            <Dialog
              open={setContactOpen}
              onClose={this.handleContactDialogClose}
              scroll="paper"
              fullWidth
              maxWidth="lg"
            >
              <DialogTitle id="scroll-dialog-title">
                {t('complaintScreenTranslations:SELECT_CONTACT_PERSON')}
              </DialogTitle>
              <DialogContent dividers>
                <Grid>
                  <Box sx={{ width: '100%', marginTop: 4, marginBottom: 4 }}>
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item xs={12} md={6}>
                        <TextField
                          id="outlined-search"
                          fullWidth
                          label={t('complaintScreenTranslations:SEARCH')}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {searchTerm !== '' ? (
                                  <IconButton aria-label="clear" onClick={this.resetSearchFilter}>
                                    <CloseOutlined sx={{ fontSize: 16 }} />
                                  </IconButton>
                                ) : null}
                                <IconButton aria-label="search" onClick={this.handleSearchContact}>
                                  <SearchOutlined />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          value={searchTerm}
                          onChange={this.handleSearchChange}
                          onKeyPress={this.handleKeyPress}
                        />
                      </Grid>
                      <Grid item xs={12} md={5} textAlign={{ xs: 'center', md: 'end' }}>
                        <Button sx={{ mr: 4 }} variant="text" onClick={this.toggleAdvanceSearch}>
                          {toggleInput
                            ? t('complaintScreenTranslations:HIDE')
                            : t('complaintScreenTranslations:SHOW')}{' '}
                          {t('complaintScreenTranslations:ADVANCED_SEARCH')}
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={1} textAlign={{ xs: 'center', md: 'end' }}>
                        <Button variant="contained" onClick={this.handleSearchContact} fullWidth>
                          {t('complaintScreenTranslations:GO')}
                        </Button>
                      </Grid>
                      {toggleInput ? (
                        <>
                          <Grid
                            item
                            container
                            xs={12}
                            sm={6}
                            md={6}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ mt: 4 }}
                          >
                            <Grid item xs={12} md={3} textAlign={{ xs: 'start', md: 'end' }}>
                              <Typography sx={{ mr: 1 }} variant="subtitle2">
                                {t('complaintScreenTranslations:CUSTOMER')}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={8} sx={{ mt: 1 }}>
                              <TextBox
                                text={customerSearchTerm}
                                tags={customerList}
                                onTextChange={this.handleCustomerTextChange}
                                onTagsChange={this.handleCustomerListChange}
                                renderTags={this.renderCustomerTags}
                              />
                            </Grid>
                          </Grid>

                          <Grid
                            item
                            container
                            xs={12}
                            sm={6}
                            md={6}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ mt: 4 }}
                          >
                            <Grid item xs={12} md={3} textAlign={{ xs: 'start', md: 'end' }}>
                              <Typography sx={{ mr: 1 }} variant="subtitle2">
                                {t('complaintScreenTranslations:NAME')}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={8} sx={{ mt: 1 }}>
                              <TextBox
                                text={nameSearchTerm}
                                tags={nameSearchTermList}
                                onTextChange={this.handleNameTextChange}
                                onTagsChange={this.handleNameListChange}
                                renderTags={this.renderNameTags}
                              />
                            </Grid>
                          </Grid>
                        </>
                      ) : null}
                    </Grid>
                  </Box>
                  <Typography sx={{ mr: 1 }} variant="subtitle2">
                    {listCount !== null
                      ? `{t("complaintScreenTranslations:ITEMS")} (${listCount})`
                      : ''}
                  </Typography>
                  {isLoading ? (
                    <TablePlaceholder columns={[0, 1]} />
                  ) : (
                    <Table
                      checkboxSelection
                      columnsConfig={columnsConfig(t)}
                      data={tableData}
                      onSelectionModelChange={this.handleModelChange}
                      selectionModel={selectedRows}
                      rowsPerPage={rowsPerPage}
                      listCount={listCount}
                      page={page}
                      onPageChange={this.handlePageChange}
                    />
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleSaveContact}
                  disabled={selectedRows.length === 0 || isLoading}
                  variant="contained"
                >
                  {t('complaintScreenTranslations:SAVE')}
                </Button>
                <Button onClick={this.handleContactDialogClose} autoFocus>
                  {t('complaintScreenTranslations:CLOSE')}
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog onClose={this.handleListDialogClose} open={open}>
              <List sx={{ pt: 0, width: 400 }}>
                {this.state[selectedField].map((c, index) => (
                  <ListItem button key={index.toString()}>
                    <ListItemText primary={c.title} />
                    <IconButton onClick={() => this.removeItems(c)}>
                      <CloseOutlined sx={{ fontSize: 16 }} />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            </Dialog>

            <Dialog open={isDialogMainOpen}>
              <DialogTitle
                id="alert-dialog-title"
                sx={{ borderBottom: `1px solid ${COLOR.borderColor}` }}
              >
                {dialogMainTitle}
              </DialogTitle>
              <DialogContent sx={{ mt: 4, mb: 2 }}>
                <DialogContentText id="alert-dialog-description">
                  {dialogMainContent}
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ borderTop: `1px solid ${COLOR.borderColor}` }}>
                <Button onClick={this.handleMainDialogClose}>
                  {' '}
                  {t('complaintScreenTranslations:DONE')}
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={setEquipmentOpen}
              onClose={this.handleEquipmentDialogClose}
              scroll="paper"
              fullWidth
              maxWidth="lg"
            >
              <DialogTitle id="scroll-dialog-title">
                {equipmentList.length > 0
                  ? t('complaintScreenTranslations:SELECT_EQUIPMENT')
                  : t('complaintScreenTranslations:NO_DATA')}{' '}
              </DialogTitle>

              <DialogContent dividers>
                <Grid>
                  <Box sx={{ width: '100%', marginTop: 4, marginBottom: 4 }}>
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item xs={12} md={6}>
                        <TextField
                          id="outlined-search"
                          fullWidth
                          label={t('complaintScreenTranslations:SEARCH')}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {searchTerm !== '' ? (
                                  <IconButton aria-label="clear" onClick={this.resetSearchFilter}>
                                    <CloseOutlined sx={{ fontSize: 16 }} />
                                  </IconButton>
                                ) : null}
                                <IconButton
                                  aria-label="search"
                                  onClick={this.handleSearchEquipment}
                                >
                                  <SearchOutlined />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          value={searchTerm}
                          onChange={this.handleSearchChange}
                          onKeyPress={this.handleKeyPressEquipment}
                        />
                      </Grid>

                      <Grid item xs={12} md={5} textAlign={{ xs: 'center', md: 'end' }}>
                        <Button
                          sx={{ mr: 4 }}
                          variant="text"
                          onClick={this.toggleAdvanceSearchEquipment}
                        >
                          {toggleEquipmentInput
                            ? t('complaintScreenTranslations:HIDE')
                            : t('complaintScreenTranslations:SHOW')}
                          {t('complaintScreenTranslations:ADVANCED_SEARCH')}
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={1} textAlign={{ xs: 'center', md: 'end' }}>
                        <Button fullWidth variant="contained" onClick={this.handleSearchEquipment}>
                          {t('complaintScreenTranslations:GO')}
                        </Button>
                      </Grid>
                      {toggleEquipmentInput ? (
                        <>
                          <Grid
                            item
                            container
                            xs={12}
                            sm={6}
                            md={6}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ mt: 4 }}
                          >
                            <Grid item xs={12} md={3} textAlign={{ xs: 'start', md: 'end' }}>
                              <Typography sx={{ mr: 1 }} variant="subtitle2">
                                {t('complaintScreenTranslations:MODEL_TEXT')}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={8} sx={{ mt: 1 }}>
                              <TextBox
                                text={modelTextTerm}
                                tags={modelTextTermList}
                                onTextChange={this.handleModelTextChange}
                                onTagsChange={this.handleModelTextListChange}
                                renderTags={this.renderModelTags}
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            container
                            xs={12}
                            sm={6}
                            md={6}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ mt: 4 }}
                          >
                            <Grid item xs={12} md={3} textAlign={{ xs: 'start', md: 'end' }}>
                              <Typography sx={{ mr: 1 }} variant="subtitle2">
                                {t('complaintScreenTranslations:LICENSE_NUMBER')}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={8} sx={{ mt: 1 }}>
                              <TextBox
                                text={licenceNumberTerm}
                                tags={licenceNumberTermList}
                                onTextChange={this.handleLicenseTextChange}
                                onTagsChange={this.handleLicenseListChange}
                                renderTags={this.renderLicenseTags}
                              />
                            </Grid>
                          </Grid>
                        </>
                      ) : null}
                    </Grid>
                  </Box>
                  <Typography sx={{ mr: 1 }} variant="subtitle2">
                    {listCount !== null
                      ? `${t('complaintScreenTranslations:ITEMS')} (${listCountEquipment})`
                      : ''}
                  </Typography>
                  {isEquipmentLoading ? (
                    <TablePlaceholder columns={[0, 1, 2]} />
                  ) : (
                    <Table
                      checkboxSelection
                      columnsConfig={columnsConfigEquipment(t)}
                      data={tableDataEquipment}
                      // isRowSelectable={params => params.row.col4 === true}
                      onSelectionModelChange={this.handleModelChange}
                      selectionModel={selectedRows}
                      rowsPerPage={rowsPerPage}
                      listCount={listCountEquipment}
                      page={page}
                      onPageChange={this.handlePageChangeEquipment}
                    />
                  )}
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={this.handleSaveEquipment}
                  disabled={selectedRows.length === 0 || isLoading}
                  variant="contained"
                >
                  {t('complaintScreenTranslations:SAVE')}
                </Button>
                <Button onClick={this.handleEquipmentDialogClose} autoFocus>
                  {t('complaintScreenTranslations:CLOSE')}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Container>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    sales: state.sales,
    auth: state.auth,
  };
};
const cComplaint = connect(mapStateToProps, {
  getCustomerTableData,
  getCustomerTableDataByFilter,
  getEquipmentList,
  submitComplaint,
  resetEquipmentData,
})(Complaint);
const tComplaint = withTranslation(['complaintScreenTranslations'])(cComplaint);

const sComplaint = withSnackbar(tComplaint);

export { sComplaint as Complaint };
